import { Button } from '@finnovate/ui';
import {
  sizeVariants,
  colorSchemeVariants,
  ButtonProps
} from '@finnovate/ui/components/Button/Button';
import styles from './gameButton.module.scss';

type GameButtonProps = {
  readonly title: string;
  onClick?: () => void;
  readonly colorScheme: keyof typeof colorSchemeVariants;
  readonly size: keyof typeof sizeVariants;
  hideButton?: boolean;
} & ButtonProps;

export default function GameButton({
  title,
  colorScheme,
  onClick,
  size,
  hideButton,
  ...props
}: GameButtonProps) {
  return (
    <Button
      onClick={onClick}
      style={hideButton ? { visibility: 'hidden' } : {}}
      className={styles.gameButton}
      colorScheme={colorScheme}
      size={size}
      {...props}
    >
      {title}
    </Button>
  );
}
